<div *ngIf="ping" class="wrapper {{message?.type}}" [ngClass]="{active: active}">
  <div class="message">
    <h3>{{message?.type}}</h3>
    <p>{{message?.message}}</p>
  </div>
  <div class="actions">
    <button (click)="close()">Close</button>
  </div>
</div>
